<template>
  <div style="width: 100%;" class="d-flex flex-column align-center">
    <!-- Selección de asignatura -->
    <h3 class="text-center font-weight-medium mb-1 mt-10">Asignatura</h3>
    <span class="text-center mb-4" style="font-size: 14px; color: #666666;">
      ¿A qué asignatura pertenece este material?
      <v-tooltip top color="black">
        <template v-slot:activator="{ on, attrs }">
          <v-icon small color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
        </template>
        <span class="text-center" style="font-size: 14px;">Asignar el material a una asignatura te ayudará a organizarte mejor.</span>
      </v-tooltip>
    </span>
    <v-autocomplete
      v-model="selectedSubject"
      :items="subjects"
      label="Selecciona la asignatura"
      item-text="name"
      item-value="id"
      outlined
      dense
      style="max-width: 300px; width: 100%; max-height: 50px;"
	  :rules="[(v) => !!v || 'Asignatura es requerida']"
      :menu-props="{ maxHeight: '400px' }"
      hide-details
	  :no-filter="true"
      class="mb-8"
    >
      <template v-slot:item="{ item }">
        <div v-if="item.isHeader" 
             class="pa-2 text-center grey--text text--darken-1" 
             style="font-size: 12px; pointer-events: none; background-color: #f5f5f5;">
          {{ item.name }}
        </div>
        <div v-else class="pa-2">
          {{ item.name }}
        </div>
      </template>
    </v-autocomplete>

    <!-- Selección de idioma -->
    <h3 class="text-center font-weight-medium mb-1">Idioma</h3>
    <span class="text-center mb-4" style="font-size: 14px; color: #666666;">
      ¿En que idioma quieres que se genere el estudio?
      <v-tooltip top color="black">
        <template v-slot:activator="{ on, attrs }">
          <v-icon small color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
        </template>
        <span class="text-center" style="font-size: 14px;">Indicar el idioma puede mejorar la calidad de los materiales.</span>
      </v-tooltip>
    </span>
    <v-autocomplete v-model="selectedLanguage" :items="languages" label="Selecciona el idioma" item-text="name" item-value="code" outlined dense style="max-width: 300px; width: 100%; max-height: 50px;" :menu-props="{ maxHeight: '400px' }" hide-details>
      <template v-slot:selection="{ item }">
        <div class="d-flex align-center">
          <v-img :src="item.bandera" class="mr-3" width="24" height="18" style="border-radius: 4px;"></v-img>
          {{ item.name }}
        </div>
      </template>
      <template v-slot:item="{ item }">
        <div class="d-flex align-center py-1">
          <v-img :src="item.bandera" class="mr-3" width="24" height="18" style="border-radius: 4px;"></v-img>
          {{ item.name }}
        </div>
      </template>
    </v-autocomplete>

    <!-- Checkbox para subir de forma anónima -->
    <div class="d-flex align-center mt-8 text-center justify-start" style="max-width: 300px; width: 100%;">
      <v-checkbox
        v-model="anonymous"
        label="Subir anónimamente"
        hide-details
        dense
        color="primary"
        style="margin: 0; padding: 0;"
      ></v-checkbox>
    </div>

    <!-- Checkbox para publicar de forma privada (siempre visible) -->
    <div class="d-flex align-center mt-8 text-center justify-center" style="max-width: 300px; width: 100%;">
      <v-checkbox
        v-model="privatePublication"
        label="Publicar de forma privada"
        hide-details
        dense
        color="primary"
        style="margin: 0; padding: 0;"
      >
        <template v-slot:label>
          <div class="d-flex align-center">
            <span :class="{ 'grey--text': !isPremium }">Publicar de forma privada</span>
        
           
          </div>
        </template>
      </v-checkbox>

	  <v-tooltip color="black">
                      <template v-slot:activator="{ on, attrs }">
                <v-icon small color="grey" v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
              </template>
              <span class="text-center" style="font-size: 14px;">
                {{ isPremium 
                  ? 'Solo tú podrás ver este documento en la comunidad. No aparecerá en búsquedas públicas.' 
                  : 'Funcionalidad disponible solo para usuarios Premium. Te permite mantener tus documentos privados.'
                }}
              </span>
            </v-tooltip>

	  <v-chip 
              v-if="!isPremium"
              x-small
              color="#FFD700"
              text-color="#4c2200"
              class="ml-2"
              style="font-weight: bold;"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-crown-icon lucide-crown mr-1">
                <path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/>
                <path d="M5 21h14"/>
              </svg>
              Premium
            </v-chip>
    </div>

    <div 
	v-if="false"
	class="mt-8" style="width: 100%; max-width: 600px;">
      <h3 class="text-center font-weight-medium">Tipos de preguntas</h3>
      <span class="text-center" style="font-size: 14px; color: #666666;">¿Qué tipo de preguntas quieres que se generen?</span>
      <div class="d-flex flex-wrap justify-center mt-4" style="gap: 16px;">
        <div v-for="type in questionTypes" :key="type.value" class="question-type-card d-flex flex-column align-center justify-center"
          :class="{ 'selected': selectedQuestionTypes.includes(type.value) }"
          @click="toggleQuestionType(type.value)">
          <div class="d-flex align-center mb-2">
            <v-icon v-if="selectedQuestionTypes.includes(type.value)" color="#4dd453" class="mr-2">mdi-check-circle</v-icon>
            <v-icon v-else color="grey" class="mr-2">mdi-checkbox-blank-circle-outline</v-icon>
          </div>
          <span class="font-weight-medium">{{ type.name }}</span>
          <span class="caption grey--text">{{ type.description }}</span>
          <span v-if="type.isPremiumType" class="premium-badge">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-crown-icon lucide-crown"><path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/><path d="M5 21h14"/></svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'StudyConfigurator',
  props: {
    isPremium: {
      type: Boolean,
      default: false
    },
    detectedLanguage: {
      type: String,
      default: 'auto'
    },
	selectedSubjectProp: {
		type: Number,
		default: null
	},
	currentDocumentId: {
		type: [Number, String],
		default: null
	}
  },
  data: () => ({
    selectedLanguage: 'auto',
    selectedQuestionTypes: ['multiple_choice', 'true_false'],
    selectedSubject: null,
    subjects: [],
    anonymous: false,
    privatePublication: false,
    questionTypes: [
      {
        name: 'Opción Múltiple',
        value: 'multiple_choice',
        description: 'Preguntas con varias opciones de respuesta',
        isPremiumType: false
      },
      {
        name: 'Verdadero o Falso',
        value: 'true_false',
        description: 'Preguntas de verdadero o falso',
        isPremiumType: false
      },
      {
        name: 'Respuesta Corta',
        value: 'short_answer',
        description: 'Preguntas que requieren una respuesta breve',
        isPremiumType: true
      },
      {
        name: 'Completar Espacios',
        value: 'fill_in_the_blank',
        description: 'Completa los espacios en blanco',
        isPremiumType: true
      },
      {
        name: 'Emparejamiento',
        value: 'matching_pairs',
        description: 'Relaciona elementos de dos columnas',
        isPremiumType: true
      },
      {
        name: 'Ordenamiento',
        value: 'ordering',
        description: 'Ordena elementos en la secuencia correcta',
        isPremiumType: true
      }
    ],
    languages: [
			// Original + Actualitzats
			{
				name: 'Automático',
				code: 'auto',
				bandera: require('@/assets/flags/auto.svg')
			},
			// --- Idiomas de España ---
			{
				name: 'Español',
				code: 'spa',
				bandera: require('@/assets/flags/ES.svg')
			},
			{
				name: 'Catalán',
				code: 'cat',
				bandera: require('@/assets/flags/catalonia.svg') // Canviat a Andorra segons disponibilitat
			},
			{
				name: 'Gallego',
				code: 'glg',
				bandera: require('@/assets/flags/galicia.svg') // Mantingut regional
			},
			{
				name: 'Euskera',
				code: 'eu', // Mantignt codi original (no 'eus' a la llista de codis)
				bandera: require('@/assets/flags/basque.svg') // Mantignt regional
			},
			// --- Idiomas Europeos Principales ---
			{
				name: 'Inglés',
				code: 'eng',
				bandera: require('@/assets/flags/GB.svg') // Canviat a GB per coherència (US també disponible)
			},
			{
				name: 'Francés',
				code: 'fra',
				bandera: require('@/assets/flags/FR.svg')
			},
			{
				name: 'Portugués',
				code: 'por',
				bandera: require('@/assets/flags/PT.svg') // Canviat a PT per origen (BR també disponible)
			},
			{
				name: 'Italiano',
				code: 'ita',
				bandera: require('@/assets/flags/IT.svg')
			},
			{
				name: 'Alemán',
				code: 'deu',
				bandera: require('@/assets/flags/DE.svg')
			},
			{
				name: 'Holandés',
				code: 'nld',
				bandera: require('@/assets/flags/NL.svg')
			},
			// --- Idiomas Eslavos ---
			{
				name: 'Ruso',
				code: 'rus',
				bandera: require('@/assets/flags/RU.svg')
			},
			{
				name: 'Polaco',
				code: 'pol',
				bandera: require('@/assets/flags/PL.svg')
			},
			{
				name: 'Ucraniano',
				code: 'ukr',
				bandera: require('@/assets/flags/UA.svg')
			},
			{
				name: 'Checo',
				code: 'ces',
				bandera: require('@/assets/flags/CZ.svg')
			},
			{
				name: 'Eslovaco', // Afegit
				code: 'slk',
				bandera: require('@/assets/flags/SK.svg')
			},
			{
				name: 'Búlgaro',
				code: 'bul',
				bandera: require('@/assets/flags/BG.svg')
			},
			{
				name: 'Serbio', // Afegit
				code: 'srp',
				bandera: require('@/assets/flags/RS.svg')
			},
			{
				name: 'Croata', // Afegit
				code: 'hrv',
				bandera: require('@/assets/flags/HR.svg')
			},
			{
				name: 'Bosnio', // Afegit
				code: 'bos',
				bandera: require('@/assets/flags/BA.svg')
			},
			{
				name: 'Esloveno', // Afegit
				code: 'slv',
				bandera: require('@/assets/flags/SI.svg')
			},
			{
				name: 'Bielorruso', // Afegit
				code: 'bel',
				bandera: require('@/assets/flags/BY.svg')
			},
			{
				name: 'Macedonio', // Afegit
				code: 'mkd',
				bandera: require('@/assets/flags/MK.svg')
			},
			// --- Idiomas Nórdicos ---
			{
				name: 'Sueco',
				code: 'swe',
				bandera: require('@/assets/flags/SE.svg')
			},
			{
				name: 'Danés',
				code: 'dan',
				bandera: require('@/assets/flags/DK.svg')
			},
			{
				name: 'Noruego (Bokmål)',
				code: 'nob',
				bandera: require('@/assets/flags/NO.svg')
			},
			{
				name: 'Finlandés',
				code: 'fin',
				bandera: require('@/assets/flags/FI.svg')
			},
			// --- Otros Idiomas Europeos ---
			{
				name: 'Griego (Moderno)',
				code: 'ell',
				bandera: require('@/assets/flags/GR.svg')
			},
			{
				name: 'Húngaro',
				code: 'hun',
				bandera: require('@/assets/flags/HU.svg')
			},
			{
				name: 'Rumano',
				code: 'ron',
				bandera: require('@/assets/flags/RO.svg')
			},
			{
				name: 'Albanés', // Afegit (Tosk)
				code: 'als',
				bandera: require('@/assets/flags/AL.svg')
			},
			{
				name: 'Lituano', // Afegit
				code: 'lit',
				bandera: require('@/assets/flags/LT.svg')
			},
			{
				name: 'Letón', // Afegit
				code: 'lvs',
				bandera: require('@/assets/flags/LV.svg')
			},
			{
				name: 'Estonio', // Afegit
				code: 'ekk',
				bandera: require('@/assets/flags/EE.svg')
			},
			// --- Idiomas Asiáticos (Este) ---
			{
				name: 'Chino (Mandarín)',
				code: 'cmn',
				bandera: require('@/assets/flags/CN.svg')
			},
			{
				name: 'Japonés',
				code: 'jpn',
				bandera: require('@/assets/flags/JP.svg')
			},
			{
				name: 'Coreano',
				code: 'kor',
				bandera: require('@/assets/flags/KR.svg')
			},
			{
				name: 'Vietnamita',
				code: 'vie',
				bandera: require('@/assets/flags/VN.svg')
			},
			{
				name: 'Tailandés',
				code: 'tha',
				bandera: require('@/assets/flags/TH.svg')
			},
			{
				name: 'Birmano', // Afegit
				code: 'mya',
				bandera: require('@/assets/flags/MM.svg')
			},
			{
				name: 'Jemer', // Afegit
				code: 'khm',
				bandera: require('@/assets/flags/KH.svg')
			},
			{
				name: 'Laosiano', // Afegit
				code: 'lao',
				bandera: require('@/assets/flags/LA.svg')
			},
			// --- Idiomas Asiáticos (Sur) ---
			{
				name: 'Hindi',
				code: 'hin',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Bengalí',
				code: 'ben',
				bandera: require('@/assets/flags/BD.svg') // Bangladesh (IN també disponible)
			},
			{
				name: 'Urdu',
				code: 'urd',
				bandera: require('@/assets/flags/PK.svg') // Pakistan (IN també disponible)
			},
			{
				name: 'Panyabí', // Afegit
				code: 'pan',
				bandera: require('@/assets/flags/IN.svg') // India (PK també disponible)
			},
			{
				name: 'Telugú', // Afegit
				code: 'tel',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Maratí', // Afegit
				code: 'mar',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Tamil', // Afegit
				code: 'tam',
				bandera: require('@/assets/flags/IN.svg') // India (LK també disponible)
			},
			{
				name: 'Guyaratí', // Afegit
				code: 'guj',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Canarés', // Afegit
				code: 'kan',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Malabar', // Afegit (Malayalam)
				code: 'mal',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Nepalí', // Afegit
				code: 'npi',
				bandera: require('@/assets/flags/NP.svg')
			},
			{
				name: 'Cingalés', // Afegit
				code: 'sin',
				bandera: require('@/assets/flags/LK.svg')
			},
			// --- Idiomas Asiáticos (Sudeste Insular) ---
			{
				name: 'Indonesio',
				code: 'ind',
				bandera: require('@/assets/flags/ID.svg')
			},
			{
				name: 'Malayo',
				code: 'zlm',
				bandera: require('@/assets/flags/MY.svg') // Malasia (ID, BN, SG també rellevants)
			},
			{
				name: 'Javanés', // Afegit
				code: 'jav',
				bandera: require('@/assets/flags/ID.svg')
			},
			{
				name: 'Sundanés', // Afegit
				code: 'sun',
				bandera: require('@/assets/flags/ID.svg')
			},
			{
				name: 'Tagalo', // Afegit
				code: 'tgl',
				bandera: require('@/assets/flags/PH.svg')
			},
			// --- Idiomas de Oriente Medio y Asia Central ---
			{
				name: 'Árabe (Estándar)',
				code: 'arb',
				bandera: require('@/assets/flags/SA.svg') // Arabia Saudí (representativa, molts països)
			},
			{
				name: 'Turco',
				code: 'tur',
				bandera: require('@/assets/flags/TR.svg')
			},
			{
				name: 'Persa (Iraní)',
				code: 'pes',
				bandera: require('@/assets/flags/IR.svg')
			},
			{
				name: 'Dari (Persa Afgano)', // Afegit
				code: 'prs',
				bandera: require('@/assets/flags/AF.svg')
			},
			{
				name: 'Hebreo',
				code: 'heb',
				bandera: require('@/assets/flags/IL.svg')
			},
			{
				name: 'Azerí', // Afegit
				code: 'azj',
				bandera: require('@/assets/flags/AZ.svg')
			},
			{
				name: 'Uzbeco', // Afegit
				code: 'uzn',
				bandera: require('@/assets/flags/UZ.svg')
			},
			{
				name: 'Kazajo', // Afegit
				code: 'kaz',
				bandera: require('@/assets/flags/KZ.svg')
			},
			{
				name: 'Turcomano', // Afegit
				code: 'tuk',
				bandera: require('@/assets/flags/TM.svg')
			},
			{
				name: 'Kirguís', // Afegit
				code: 'kir',
				bandera: require('@/assets/flags/KG.svg')
			},
			{
				name: 'Tayiko', // Afegit
				code: 'tgk',
				bandera: require('@/assets/flags/TJ.svg')
			},
			{
				name: 'Armenio', // Afegit
				code: 'hye',
				bandera: require('@/assets/flags/AM.svg')
			},
			{
				name: 'Georgiano', // Afegit
				code: 'kat',
				bandera: require('@/assets/flags/GE.svg')
			},
			// --- Idiomas Africanos ---
			{
				name: 'Suajili', // Afegit
				code: 'swh',
				bandera: require('@/assets/flags/KE.svg') // Kenia (TZ, UG també rellevants)
			},
			{
				name: 'Hausa', // Afegit
				code: 'hau',
				bandera: require('@/assets/flags/NG.svg') // Nigeria (NE també rellevant)
			},
			{
				name: 'Amárico', // Afegit
				code: 'amh',
				bandera: require('@/assets/flags/ET.svg')
			},
			{
				name: 'Yoruba', // Afegit
				code: 'yor',
				bandera: require('@/assets/flags/NG.svg') // Nigeria (BJ també rellevant)
			},
			{
				name: 'Igbo', // Afegit
				code: 'ibo',
				bandera: require('@/assets/flags/NG.svg')
			},
			{
				name: 'Zulú', // Afegit
				code: 'zul',
				bandera: require('@/assets/flags/ZA.svg')
			},
			{
				name: 'Xhosa', // Afegit
				code: 'xho',
				bandera: require('@/assets/flags/ZA.svg')
			},
			{
				name: 'Afrikáans', // Afegit
				code: 'afr',
				bandera: require('@/assets/flags/ZA.svg') // Sudáfrica (NA també rellevant)
			},
			{
				name: 'Somalí', // Afegit
				code: 'som',
				bandera: require('@/assets/flags/SO.svg')
			},
			{
				name: 'Shona', // Afegit
				code: 'sna',
				bandera: require('@/assets/flags/ZW.svg')
			},
			{
				name: 'Wólof', // Afegit
				code: 'wol',
				bandera: require('@/assets/flags/SN.svg')
			},
			// --- Idiomas Americanos (Nativos/Criollos) ---
			{
				name: 'Criollo Haitiano', // Afegit
				code: 'hat',
				bandera: require('@/assets/flags/HT.svg')
			},
			// ... (Podrían añadirse Quechua, Guaraní, etc., si hubiera códigos y banderas representativas disponibles)

			// --- Otros (Esperanto, etc.) ---
			{
				name: 'Esperanto', // Afegit
				code: 'epo',
				bandera: require('@/assets/flags/AQ.svg') // Bandera Antártida (Símbolo Neutral / Placeholder)
			}
		],
  }),
  async mounted() {
	await this.fetchSubjects()

    // this.fetchSubjects().then(() => {
    //   // Obtener el subject ID de la URL
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const subjectId = urlParams.get('subject');
      
    //   if (subjectId) {
    //     // Convertir a número ya que los IDs suelen ser numéricos
    //     this.selectedSubject = parseInt(subjectId);
	// 	this.$emit('update:detectedLanguage', this.selectedLanguage);
	// 	this.$emit('update:selectedSubjectProp', this.selectedSubject);
    //   }
    // });

    // Establecer privatePublication por defecto si es premium
    if (this.isPremium) {
      this.privatePublication = true;
    }

    // Intentar restaurar el contexto guardado si el usuario acaba de hacerse premium
    this.restoreContextIfAvailable();
  },
  methods: {
    toggleQuestionType(type) {
      const questionType = this.questionTypes.find(qt => qt.value === type);
      if (questionType.isPremiumType && !this.isPremium) {
        // Emit an event to the parent to show the premium dialog
        this.$emit('show-premium-dialog');
        return;
      }

      const index = this.selectedQuestionTypes.indexOf(type);
      if (index === -1) {
        this.selectedQuestionTypes.push(type);
      } else {
        this.selectedQuestionTypes.splice(index, 1);
      }
    },
    // Method to expose the selected config to the parent
    getConfig() {
      return {
        selectedLanguage: this.selectedLanguage,
        selectedQuestionTypes: this.selectedQuestionTypes,
        selectedSubject: this.selectedSubject === 'separator' ? null : this.selectedSubject,
        anonymous: this.anonymous,
        privatePublication: this.privatePublication
      };
    },
    // Method to assign document to subject
    async assignDocumentToSubject(documentId) {
      if (!this.selectedSubject || !documentId) return;

      try {
        const community_id = this.$root.currentUser?.educationInfo?.education?.community_id || 2027;
        await axios.post('/assign-document', {
          document_id: documentId,
          subject_id: this.selectedSubject,
          anonymous: this.anonymous,
          community_id: community_id,
          language_code: this.selectedLanguage,
		  language: this.languages.find(l => l.code === this.selectedLanguage).name,
		  show_community: !this.privatePublication // Si privatePublication está marcada, show_community es false
        }, {
          headers: {
            Authorization: this.$root.token.value
          }
        });
      } catch (error) {
        console.error('Error al asignar documento a la asignatura:', error);
        this.$toast.error('Error al asignar el documento a la asignatura');
      }
    },
    // Method to fetch user's subjects
    async fetchSubjects() {
      try {
        // Obtener community_id de la ruta o usar 2027 por defecto
        const urlParams = new URLSearchParams(window.location.search);
        const community_id = urlParams.get('community_id') || 
                           this.$root.currentUser?.educationInfo?.education?.community_id || 
                           2027;

        // Hacer ambas llamadas en paralelo
        const [userSubjectsResponse, communitySubjectsResponse] = await Promise.all([
          axios.get('/education/user-subjects?user_id=' + this.$root.currentUser.userId, {
            headers: {
              Authorization: this.$root.token.value
            }
          }),
          axios.get('/education/subjects?community_id=' + community_id, {
            headers: {
              Authorization: this.$root.token.value
            }
          })
        ]);

        let subjects = [];

        // Agregar asignaturas del usuario
        if (userSubjectsResponse.data && Array.isArray(userSubjectsResponse.data)) {
          subjects = [...userSubjectsResponse.data];
        }

        // Crear conjunto de IDs de asignaturas del usuario para evitar duplicados
        const userSubjectIds = new Set(subjects.map(subject => subject.id));

        // Agregar separador si hay asignaturas del usuario
        if (subjects.length > 0 && (!communitySubjectsResponse.data || subjects.length !== communitySubjectsResponse.data.length)) {
          subjects.push({
            id: 'separator',
            name: '─────── Otras asignaturas ───────',
            disabled: true,
            isHeader: true
          });
        }

        // Agregar asignaturas de la comunidad que no estén ya en las del usuario
        if (communitySubjectsResponse.data && Array.isArray(communitySubjectsResponse.data)) {
          const communitySubjects = communitySubjectsResponse.data.filter(
            subject => !userSubjectIds.has(subject.id)
          );
          subjects = [...subjects, ...communitySubjects];
        }

		console.log(subjects)
        this.subjects = subjects;
      } catch (err) {
        console.error('Error al cargar las asignaturas:', err);
      }
    },
    handleUpgradeWithContext() {
      // Guardar el estado actual en localStorage para poder recuperarlo después del upgrade
      const currentContext = {
        documentId: this.currentDocumentId,
        selectedLanguage: this.selectedLanguage,
        selectedQuestionTypes: this.selectedQuestionTypes,
        selectedSubject: this.selectedSubject,
        anonymous: this.anonymous,
        privatePublication: true, // Lo marcamos como true para cuando regrese siendo premium
        timestamp: Date.now(),
        returnPath: this.$route.fullPath
      };
      
      localStorage.setItem('studyConfiguratorContext', JSON.stringify(currentContext));
      
      // Emitir evento al componente padre para mostrar el diálogo de premium con el premium_from
      this.$emit('show-premium-dialog', { premium_from: 'study_configurator' });
    },
    // Method to restore context if available
    restoreContextIfAvailable() {
      const storedContext = localStorage.getItem('studyConfiguratorContext');
      if (storedContext) {
        try {
          const context = JSON.parse(storedContext);
          
          // Verificar que el contexto no sea muy antiguo (más de 1 hora)
          const oneHourInMs = 60 * 60 * 1000;
          if (Date.now() - context.timestamp > oneHourInMs) {
            this.clearStoredContext();
            return;
          }

          // Solo restaurar si somos premium y el contexto tiene sentido
          if (this.isPremium && context.documentId === this.currentDocumentId) {
            this.selectedLanguage = context.selectedLanguage || this.selectedLanguage;
            this.selectedQuestionTypes = context.selectedQuestionTypes || this.selectedQuestionTypes;
            this.selectedSubject = context.selectedSubject || this.selectedSubject;
            this.anonymous = context.anonymous !== undefined ? context.anonymous : this.anonymous;
            this.privatePublication = context.privatePublication !== undefined ? context.privatePublication : this.privatePublication;
            
            this.$emit('update:detectedLanguage', this.selectedLanguage);
            this.$emit('update:selectedSubjectProp', this.selectedSubject);
            
            // Limpiar el contexto después de restaurarlo
            this.clearStoredContext();
            
            // Mostrar mensaje de confirmación
            this.$toast.success('Configuración restaurada después de actualizar a Premium');
          }
        } catch (error) {
          console.error('Error restaurando contexto:', error);
          this.clearStoredContext();
        }
      }
    },
    // Method to clear stored context
    clearStoredContext() {
      localStorage.removeItem('studyConfiguratorContext');
    }
  },
  watch: {
    detectedLanguage: {
      handler(newVal) {
        this.selectedLanguage = newVal;
      }
    },
	selectedLanguage: {
		handler(newVal) {
			this.$emit('update:detectedLanguage', newVal);
		}
	},
	selectedSubject: {
		handler(newVal) {
			this.$emit('update:selectedSubjectProp', newVal);
		}
	},
	// Watch for premium status changes
	isPremium: {
		handler(newVal, oldVal) {
			if (newVal && !oldVal) {
				// User just became premium, try to restore context
				this.restoreContextIfAvailable();
			}
		}
	},
	// Watch for privatePublication changes
	privatePublication: {
		handler(newVal, oldVal) {
			// Si el usuario intenta marcar como privado pero no es premium
			if (newVal && !this.isPremium) {
				// Resetear el valor a false inmediatamente
				this.$nextTick(() => {
					this.privatePublication = false;
				});
				
				// Abrir el diálogo de premium con contexto
				this.handleUpgradeWithContext();
			}
		}
	}
  },
  beforeDestroy() {
    // Optional: Clear context when component is destroyed if needed
    // this.clearStoredContext();
  }
}
</script>

<style scoped>
.question-type-card {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: calc(33.33% - 11px);
  min-width: 180px;
  max-width: 250px;
  position: relative;
}

.question-type-card:hover {
  border-color: #4dd453;
  background-color: rgba(77, 212, 83, 0.05);
}

.question-type-card.selected {
  border-color: #4dd453;
  background-color: rgba(77, 212, 83, 0.05);
}

.premium-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #FFD700;
  color: #4c2200;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-weight: bold;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-autocomplete>>>.v-select__selection {
  margin-top: 2px;
}

.v-autocomplete>>>.v-input__slot {
  min-height: 42px !important;
}

.v-autocomplete>>>.v-text-field__slot input {
  font-size: 14px;
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
}

.v-autocomplete>>>.v-select__selections {
  padding-top: 2px;
}
</style> 